module.exports = __webpack_public_path__ + "static/media/partner.22c195a1.png";